import React, {useEffect} from "react";
import { motion } from "framer-motion";
import Header from "../Components/Header";
import heroImg from '../Images/about-hero.webp'
import BreadcrumbMain from "../Components/BreadcrumbMain";
import { values } from "../Data";
import StatsBox from "../Components/StatsBox";
import Services from "../Components/Services";
import lorenzaImg from '../Images/lorenza-de-luca.webp'
import Cta from "../Components/Cta";
import AwardsSection from "../Components/AwardsSection";
import SchemaMarkup from "../Components/SchemaMarkup";
import breadcrumbSchema from '../Schemas/breadcrumbSchema'

const About=()=>{
      useEffect(() => {
        document.title =
          "About LDL Settlement Services | Trusted Perth Settlement Agents";
    
        const metaDesc = document.querySelector("meta[name='description']");
        if (metaDesc) {
          metaDesc.setAttribute(
            "content",
            "Learn more about LDL Settlement Services, a trusted Perth settlement agency providing professional property settlement solutions across Western Australia."
          );
        }
    
        const canonical = document.querySelector("link[rel='canonical']");
      if (canonical) {
        canonical.setAttribute("href", "https://ldlsettlementservices.com.au/about-us");
      }
    
      const ogTitle = document.querySelector("meta[property='og:title']");
      if (ogTitle) {
        ogTitle.setAttribute(
          "content",
          "About LDL Settlement Services | Trusted Perth Settlement Agents"
        );
      }
    
        const ogDesc = document.querySelector("meta[property='og:description']");
      if (ogDesc) {
        ogDesc.setAttribute(
          "content",
          "Learn more about LDL Settlement Services, a trusted Perth settlement agency providing professional property settlement solutions across Western Australia."
        );
      }
    
    const ogUrl = document.querySelector("meta[property='og:url']");
      if (ogUrl) {
        ogUrl.setAttribute("content", "https://ldlsettlementservices.com.au/about-us");
      }
    
        const ogImage = document.querySelector("meta[property='og:image']");
      if (ogImage) {
        ogImage.setAttribute(
          "content",
          "https://ldlsettlementservices.com.au/Images/about-img.webp"
        );
      }
    
        const twitterTitle = document.querySelector("meta[name='twitter:title']");
      if (twitterTitle) {
        twitterTitle.setAttribute(
          "content",
          "About LDL Settlement Services | Trusted Perth Settlement Agents"
        );
      }
    
        const twitterDesc = document.querySelector(
        "meta[name='twitter:description']"
      );
      if (twitterDesc) {
        twitterDesc.setAttribute(
          "content",
          "Learn more about LDL Settlement Services, a trusted Perth settlement agency providing professional property settlement solutions across Western Australia."
        );
      }
    
        const twitterImage = document.querySelector("meta[name='twitter:image']");
      if (twitterImage) {
        twitterImage.setAttribute(
          "content",
          "https://ldlsettlementservices.com.au/Images/about-img.webp"
        );
      }
      }, []);

  const breadcrumbs = breadcrumbSchema([
  {
    name: "Home",
    url: "https://ldlsettlementservices.com.au/"
  },
  {
    name: "About Us"
  }
]);
    
    return(
        <>

      <SchemaMarkup schema={breadcrumbs} />

        {/**HEADER */}
         <Header
        showBreadcrumb={true}
        pageName="About us"
      />

      {/**HERO SECTION */}
       <BreadcrumbMain
      subTitle="ABOUT LDL SETTLEMENT SERVICES"
      title="Trusted. Experienced.
Focused on You."
      description="LDL Settlement Services is a Perth-based settlement agency providing professional, reliable and transparent solutions for property transactions across Western Australia."
      image={heroImg}
      showIcons={true}
    />

    {/**ABOUT LDL SETTLEMENT SERVICES */}
   <section className="about-values">

  <motion.div
    className="container about-values-container"
    initial="hidden"
    whileInView="visible"
    viewport={{
      once: true,
      amount: 0.12,
    }}
    variants={{
      hidden: {},
      visible: {
        transition: {
          staggerChildren: 0.18,
        },
      },
    }}
  >

    {/* LEFT SIDE */}

    <motion.div
      className="about-left"
      variants={{
        hidden: {
          opacity: 0,
          x: -60,
        },
        visible: {
          opacity: 1,
          x: 0,
          transition: {
            duration: 1,
            ease: [0.22, 1, 0.36, 1],
          },
        },
      }}
    >

      <motion.h2
        className="section-heading"
        initial={{
          opacity: 0,
          y: 35,
        }}
        whileInView={{
          opacity: 1,
          y: 0,
        }}
        transition={{
          duration: 0.9,
          ease: [0.22, 1, 0.36, 1],
        }}
        viewport={{
          once: true,
        }}
      >
        About <span>LDL Settlement Services</span>
      </motion.h2>

      <motion.p
        className="section-text"
        initial={{
          opacity: 0,
          y: 45,
        }}
        whileInView={{
          opacity: 1,
          y: 0,
        }}
        transition={{
          duration: 1,
          delay: 0.15,
          ease: [0.22, 1, 0.36, 1],
        }}
        viewport={{
          once: true,
        }}
      >
        Established over 20 years ago, LDL Settlement Services has built a strong reputation for accuracy, professionalism, and exceptional client care. What began as a boutique local agency has grown into one of Western Australia’s most trusted settlement partners, built entirely on word-of-mouth recommendations, lasting industry relationships, and repeat clientele who trust us time and time again with their most significant assets. We work closely with individuals, families, investors, businesses, and industry professionals to deliver seamless settlement experiences tailored to your unique goals. Whether you are a first-time homebuyer navigating a simple residential purchase, an investor expanding your portfolio, or a seasoned developer executing complex commercial property transactions, our team possesses the depth of knowledge and technical expertise required to safeguard your interests at every turn. The Western Australian property market is nuanced and constantly evolving. Our deep local knowledge, sharp attention to detail, and unwavering commitment to integrity set us apart in a competitive industry. We don't just process paperwork; we actively anticipate potential challenges, stay ahead of changing compliance regulations, manage the heavy lifting behind the scenes, and maintain clear communication to ensure your property journey culminates in a smooth, successful, and entirely stress-free settlement.
      </motion.p>

    </motion.div>

    {/* RIGHT SIDE */}

    <motion.div
      className="about-right"
      variants={{
        hidden: {
          opacity: 0,
          x: 60,
        },
        visible: {
          opacity: 1,
          x: 0,
          transition: {
            duration: 1,
            ease: [0.22, 1, 0.36, 1],
          },
        },
      }}
    >

      <motion.h2
        className="section-heading"
        initial={{
          opacity: 0,
          y: 35,
        }}
        whileInView={{
          opacity: 1,
          y: 0,
        }}
        transition={{
          duration: 0.9,
          ease: [0.22, 1, 0.36, 1],
        }}
        viewport={{
          once: true,
        }}
      >
        Our <span>Values</span>
      </motion.h2>

      <motion.div
        className="values-list"
        variants={{
          hidden: {},
          visible: {
            transition: {
              staggerChildren: 0.12,
            },
          },
        }}
      >

        {values.map((item, index) => (

          <motion.div
            className="value-card"
            key={index}
            initial={{
              opacity: 0,
              y: 40,
              scale: 0.97,
            }}
            whileInView={{
              opacity: 1,
              y: 0,
              scale: 1,
            }}
            transition={{
              duration: 0.8,
              delay: index * 0.1,
              ease: [0.22, 1, 0.36, 1],
            }}
            viewport={{
              once: true,
            }}
            whileHover={{
              y: -6,
            }}
          >

            <motion.div
              className="value-icon"
              whileHover={{
                scale: 1.08,
                rotate: -3,
              }}
              transition={{
                duration: 0.35,
              }}
            >
              <img
                src={item.icon}
                alt={`${item.title} | LDL Settlement Services`}
              />
            </motion.div>

            <div className="value-content">

              <h3 className="card-heading">
                {item.title}
              </h3>

              <p className="section-text">
                {item.desc}
              </p>

            </div>

          </motion.div>

        ))}

      </motion.div>

    </motion.div>

  </motion.div>

</section>

    {/**STATS SECTION */}
    <StatsBox />

    {/**SERVICES GRID */}
    <Services
        isSlider={false}
    />

    {/**MMET LORENZA DE LUCA SECTION */}
    <section className="meet-section container">

  {/* LEFT IMAGE */}

  <motion.div
    className="meet-left"
    initial={{
      opacity: 0,
      x: -70,
      scale: 0.96,
    }}
    whileInView={{
      opacity: 1,
      x: 0,
      scale: 1,
    }}
    transition={{
      duration: 1.1,
      ease: [0.22, 1, 0.36, 1],
    }}
    viewport={{
      once: true,
      amount: 0.2,
    }}
  >

    <motion.img
      src={lorenzaImg}
      alt="Lorenza De Luca | LDL Settlement Services"
      whileHover={{
        scale: 1.03,
      }}
      transition={{
        duration: 0.5,
        ease: [0.22, 1, 0.36, 1],
      }}
    />

  </motion.div>

  {/* RIGHT CONTENT */}

  <motion.div
    className="meet-right"
    initial="hidden"
    whileInView="visible"
    viewport={{
      once: true,
      amount: 0.2,
    }}
    variants={{
      hidden: {},
      visible: {
        transition: {
          staggerChildren: 0.15,
        },
      },
    }}
  >

    <motion.p
      className="hero-subtitle"
      variants={{
        hidden: {
          opacity: 0,
          y: 30,
        },
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 0.8,
            ease: [0.22, 1, 0.36, 1],
          },
        },
      }}
    >
      LEADERSHIP YOU CAN TRUST
    </motion.p>

    <motion.h2
      className="section-heading"
      variants={{
        hidden: {
          opacity: 0,
          y: 40,
        },
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 0.9,
            ease: [0.22, 1, 0.36, 1],
          },
        },
      }}
    >
     Lorenza De Luca
    </motion.h2>

    <motion.p
      className="special-text"
      variants={{
        hidden: {
          opacity: 0,
          y: 30,
        },
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 0.85,
            ease: [0.22, 1, 0.36, 1],
          },
        },
      }}
    >
      Director & Licensed Settlement Agent
    </motion.p>

    <motion.p
      className="section-text"
      variants={{
        hidden: {
          opacity: 0,
          y: 45,
        },
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 1,
            ease: [0.22, 1, 0.36, 1],
          },
        },
      }}
    >
      Lorenza De Luca is the driving force behind LDL Settlement Services, bringing more than 20 years of experience in the Western Australian property industry. Known for her precision, reliability, and client-first approach, Lorenza has built a strong reputation for delivering smooth and stress-free settlement experiences for buyers, sellers, investors, and businesses alike. Her expertise spans residential, commercial, and independent real estate settlements, allowing her to confidently manage transactions of all complexities with professionalism and care.With a strong focus on clear communication, transparency, and personalised service, Lorenza is committed to ensuring every client feels informed and supported throughout the settlement process. Her dedication to excellence and attention to detail have helped establish LDL Settlement Services as a trusted name across Perth and WA. In recognition of her leadership, professionalism, and contribution to the business community, Lorenza was proudly nominated in the 2023 Business News 40 Under 40 Awards. She is also a recognised PEXA Member and a proud Member of the Australian Institute of Conveyancers – WA (AICWA), reflecting her commitment to industry best practices and modern settlement solutions. Beyond her technical expertise, Lorenza is passionate about building long-term relationships founded on trust, integrity, and genuine care for her clients. She works closely with real estate agents, financial institutions, and legal professionals to ensure every transaction is handled efficiently and with the highest level of accuracy. Her approachable nature, industry knowledge, and commitment to achieving the best outcomes continue to make her a respected and trusted figure within Western Australia’s property and settlement industry.
    </motion.p>

  </motion.div>

</section>

    {/**AWARDS SECTION */}
   <AwardsSection />

    {/**CTA SECTION */}
    <Cta />
        </>
    )
}
export default About;